export default {
  feedback(state) {
    return state.feedback
  },
  feedbackHistory(state) {
    return state.feedbackHistory
  },
  feedbacks(state) {
    return state.feedbacks
  },
  feedbackManagers(state) {
    return state.feedbackManagers
  },
  feedbackOrders(state) {
    return state.feedbackOrders
  },
  feedbackFilters(state) {
    return state.feedbackFilters
  },
  feedbackErrors(state) {
    return state.feedbackErrors
  },
  feedbackMasterVotes(state) {
    return state.feedbackMasterVotes
  },
  feedbackFilterStatus(state) {
    return state.feedbackFilterStatus
  },
  feedbackServiceVotes(state) {
    return state.feedbackServiceVotes
  },
  orderByHash(state) {
    return state.orderByHash
  },
}
